import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center mb-6">
              <span className="text-3xl font-heading font-bold text-white tracking-tight">MEHR</span>
              <span className="text-3xl font-heading font-bold text-primary tracking-tight">AZAV</span>
            </Link>
            <p className="text-muted-foreground max-w-md leading-relaxed mb-6">
              Beratung und Begleitung für Bildungsträger im AZAV-Kontext. 
              Von der Gründung bis zum erfolgreichen Audit.
            </p>
            <div className="flex items-center gap-4">
              <a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary/30 transition-all"
                data-testid="footer-linkedin"
              >
                <Linkedin size={18} />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-white font-heading font-semibold mb-6">Navigation</h4>
            <ul className="space-y-4">
              <li>
                <Link to="/" className="text-muted-foreground hover:text-primary transition-colors" data-testid="footer-link-home">
                  Startseite
                </Link>
              </li>
              <li>
                <Link to="/leistungen" className="text-muted-foreground hover:text-primary transition-colors" data-testid="footer-link-services">
                  Leistungen
                </Link>
              </li>
              <li>
                <Link to="/ratgeber" className="text-muted-foreground hover:text-primary transition-colors" data-testid="footer-link-ratgeber">
                  Ratgeber
                </Link>
              </li>
              <li>
                <Link to="/ueber-uns" className="text-muted-foreground hover:text-primary transition-colors" data-testid="footer-link-about">
                  Über uns
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-muted-foreground hover:text-primary transition-colors" data-testid="footer-link-contact">
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-heading font-semibold mb-6">Kontakt</h4>
            <ul className="space-y-4">
              <li>
                <a 
                  href="mailto:hey@mehrazav.de" 
                  className="text-muted-foreground hover:text-primary transition-colors flex items-center gap-3"
                  data-testid="footer-email"
                >
                  <Mail size={16} className="text-primary" />
                  hey@mehrazav.de
                </a>
              </li>
              <li>
                <a 
                  href="tel:+4912345678" 
                  className="text-muted-foreground hover:text-primary transition-colors flex items-center gap-3"
                  data-testid="footer-phone"
                >
                  <Phone size={16} className="text-primary" />
                  +49 176 7040 1954
                </a>
              </li>
              <li className="flex items-start gap-3 text-muted-foreground">
                <MapPin size={16} className="text-primary mt-1 flex-shrink-0" />
                <span>
                  Zum Großen Zernsee 2H<br />
                  14542 Werder (Havel)
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-muted-foreground text-sm">
            © {currentYear} MEHRAZAV. Alle Rechte vorbehalten.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/datenschutz" className="text-muted-foreground hover:text-primary text-sm transition-colors" data-testid="footer-privacy">
              Datenschutz
            </Link>
            <Link to="/impressum" className="text-muted-foreground hover:text-primary text-sm transition-colors" data-testid="footer-imprint">
              Impressum
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
